import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseService } from '../shared/services/base.service';
import { Subscription } from 'rxjs';
import { AuthService } from '../shared/services/auth.service';
import { Router } from '@angular/router';
import { UserService } from '../user/services/user.service';
import { RolePermission } from '../shared/models/role.permission.enum';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.scss']
})
export class NavMenuComponent implements OnInit, OnDestroy {
  isExpanded = false;

  private usernameSubscription: Subscription;

  username: string;
  isIDIAdmin: boolean;
  isDealerAdmin: boolean;
  isFieldTech: boolean;

  hideQuoteTabs: boolean;
  quoteOnly: boolean;
  locale: string = 'en';

  constructor(private router: Router, private userService: UserService) {}

  ngOnInit() {
     this.usernameSubscription = AuthService.authNavStatus$.subscribe(authenticated => {
      this.username = "";
      if (authenticated) {
        let user = AuthService._authUserSource.value;
        this.username = user.firstName;
        this.quoteOnly = user.isQuoteOnly;

        this.isIDIAdmin = authenticated == 'IDI';
        this.isDealerAdmin = BaseService.hasPermission(RolePermission.Admin) && authenticated == 'Dealer';
        this.isFieldTech = BaseService.hasPermission(RolePermission.FieldTechnician);

        this.locale = user?.locale ?? 'en';
        this.hideQuoteTabs = this.isFieldTech || this.isIDIAdmin;
      }
    });
  }

  ngOnDestroy() {
    this.usernameSubscription.unsubscribe();
  }

  get hideJobTools(): boolean {
    return this.isIDIAdmin || this.quoteOnly;
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  updateLocale(): void {
    this.userService.updateLocale(this.locale)
      .subscribe({
        next: (data) => {
          this.userService.loginUser(data);
          window.location.href = `/${this.locale}/index.html`;
        }
      });
  }

  logout(event: any) {
    event.preventDefault();

    BaseService.logout(this.router);
  }
}
